import { render, staticRenderFns } from "./BetGameNew.vue?vue&type=template&id=7e596052&scoped=true&"
import script from "./BetGameNew.vue?vue&type=script&lang=js&"
export * from "./BetGameNew.vue?vue&type=script&lang=js&"
import style0 from "./BetGameNew.vue?vue&type=style&index=0&id=7e596052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e596052",
  null
  
)

component.options.__file = "BetGameNew.vue"
export default component.exports